/**
 * Platform targets available for the ODT v2 (Level Access Desktop) download.
 */
export enum Odt2Platform {
  macos = 'odt2_macos',
  winX64 = 'odt2_win_x64',
  winArm64 = 'odt2_win_arm64',
  debX64 = 'odt2_deb_x64',
  debArm64 = 'odt2_deb_arm64',
  rpmX64 = 'odt2_rpm_x64',
  rpmArm64 = 'odt2_rpm_arm64',
}
